import {BasePage} from './base';

import {PopupUtils} from '../tools/popup';

import '@styles/common/_header.scss';
import '@styles/index.scss';
import '@styles/menu.scss';
import '@styles/modal.scss';
import '@styles/btns.scss';
import '@styles/common/_forms.scss';
import '@fontsource/montserrat';

import FormBase from '../forms/base.js';
import ymaps from 'ymaps';

import '@styles/product-detail.scss';

import Swiper from 'swiper';
import {Navigation, Thumbs} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {
    const sideMenu = document.getElementById('sideMenu');
    const overlay = document.getElementById('menuOverlay');
    const openBtn = document.getElementById('openMenuBtn');
    const closeBtn = document.getElementById('closeMenuBtn');

    function openMenu() {
        sideMenu.classList.add('open');
        overlay.classList.add('show');
        document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
        sideMenu.classList.remove('open');
        overlay.classList.remove('show');
        document.body.style.overflow = '';
    }

    overlay.addEventListener('click', closeMenu);
    openBtn.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sideMenu.classList.contains('open')) closeMenu();
    });

    const galleryThumbs = new Swiper('.product-gallery-thumbs', {
        modules: [Thumbs],
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
    });

    const galleryMain = new Swiper('.product-gallery-main', {
        modules: [Navigation, Thumbs],
        slidesPerView: 1,
        navigation: {
            prevEl: '.product-gallery-main .swiper-button-prev',
            nextEl: '.product-gallery-main .swiper-button-next',
        },
        thumbs: {
            swiper: galleryThumbs,
        },
        on: {
            slideChange(swiper) {
                swiper.slides.forEach(slide => {
                    const video = slide.querySelector('video');
                    if (video) video.pause();
                });
            },
        },
    });
});